import { render, staticRenderFns } from "./Typeform.vue?vue&type=template&id=574ef899&scoped=true&"
import script from "./Typeform.vue?vue&type=script&lang=js&"
export * from "./Typeform.vue?vue&type=script&lang=js&"
import style0 from "./Typeform.vue?vue&type=style&index=0&id=574ef899&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ef899",
  null
  
)

export default component.exports